import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import RestService from "./../../Restservice";
import GlobalHelmet from "./../../GlobalHelmet";
import { Link } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Common from "./../../common.json";
import Faq from "./FAQ";

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

export default function Index() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [showStatus, setShowStatus] = useState(-1);
  const [value, setValue] = React.useState("all");
  const [open, setOpen] = React.useState(false);

  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    setLoading(true);
    RestService.getFundamentalScreener(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data);
        setShowStatus(response.data.status);
      },
      mobile,
      web_token,
      value
    );
  }, [mobile, web_token, value]);

  const handleClose = (res) => {
    setOpen(false);
  };

  const openProModal = () => {
    setOpen(true);
  };
  return (
    <>
      <GlobalHelmet {...Common?.fundamentalScreener} />
      {loading ? <Loader /> : ""}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Buy Premium Service</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This is premium service, please buy our service.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button onClick={handleClose} className="btn btn-default">
            Close
          </button>
          <Link to="/subscription" target="_blank" className="btn btn-success">
            Buy Now
          </Link>
        </DialogActions>
      </Dialog>
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-md-12">
              <Breadcrumbs page="Fundamental Screener" />

              <div className="row onerowsync">
              <div className="col-sm-12">
                <p>Get fundamental analysis for stocks, fundamental stock analysis like undervalued stocks, overvalued stocks, low PE stocks, high dividend stocks, low price stocks, values stocks, stocks under 50, stocks under 30, growth stocks, low debt to equity stocks, high ROE stocks, high ROCE stocks, high growth stocks, high earning per share stocks, high EPS stocks, high profit margin stocks, high operating profit margin stocks, high OPM stocks, high NPM stocks, high sales stocks etc. Explore many other fundamental stock screeners, technical vs fundamental analysis etc.</p>
              </div>
                <div className="col-sm-6">
                  <RadioGroup
                    aria-label="signaltype"
                    name="signaltype"
                    value={value}
                    onChange={handleChange}
                  >
                    <div className="row">
                      {/* <div className="col-sm-2" ></div> */}
                      <div className="col-3">
                        <FormControlLabel
                          value="61"
                          control={<Radio />}
                          label="FNO"
                        />
                      </div>
                      <div className="col-3">
                        <FormControlLabel
                          value="64"
                          control={<Radio />}
                          label={"NIFTY\n500"}
                        />
                      </div>
                      <div className="col-3">
                        <FormControlLabel
                          value="all"
                          control={<Radio />}
                          label="NSE ALL"
                        />
                      </div>
                    </div>
                  </RadioGroup>
                </div>
                <div className="col-sm-6"></div>
                <div className="col-12">
                  <button className="btn btn-default mb-4">Free</button>
                </div>
                <div className={classes.root}>
                  <Grid container spacing={2}>
                    {globaldata ? (
                      globaldata?.getDetails.map((items) => (
                        <Grid item key={items.id} xs={6} sm={4} md={4} lg={2}>
                          <Link
                            to={
                              "/fundamental-analysis/" +
                              items.slug +
                              "/" +
                              value
                            }
                          >
                            <Paper
                              className={"custom-grid-style " + classes.paper}
                            >
                              {items.name}
                            </Paper>
                          </Link>
                        </Grid>
                      ))
                    ) : (
                      <Loader />
                    )}
                  </Grid>
                </div>
                <hr />
                <div className="col-12">
                  <button className="btn btn-default mt-4 mb-4">Paid</button>
                </div>
                <div className={classes.root}>
                  <Grid container spacing={2}>
                    {globaldata ? (
                      globaldata?.getServiceDetails.map((items) => (
                        <Grid item key={items.slug} xs={6} sm={4} md={4} lg={2}>
                          {showStatus > 0 ? (
                            <Link
                              to={
                                "/fundamental-analysis/" +
                                items.slug +
                                "/" +
                                value
                              }
                            >
                              <Paper
                                className={"custom-grid-style " + classes.paper}
                              >
                                {items.name}
                              </Paper>
                            </Link>
                          ) : (
                            <Paper
                              className={"custom2-grid-style " + classes.paper}
                              style={{
                                backgroundColor: "#dfdfdf",
                                cursor: "pointer",
                              }}
                              onClick={openProModal}
                            >
                              {items.name}
                            </Paper>
                          )}
                        </Grid>
                      ))
                    ) : (
                      <Loader />
                    )}
                  </Grid>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
              <div className="col-sm-12"><Faq/> </div>
          </div>
        </div>
      </div>
    </>
  );
}
